import useUser from "./use-user";

export default function useUserCompletedTasks() {
    const {completedTasks} = useUser()

    return completedTasks
}
